<template>
	<coming-soon />
	<!-- <div>
				<settings-alerts
			:isError="isError"
			:isSuccess="isSuccess"
			@toggleSucces="(value) => (isSuccess = value)"
			@toggleError="(value) => (isError = value)"
		/>

		<div class="d-flex">
			<div
				class="d-flex flex-column justify-space-between notifications-titles-container"
			>
				<div class="grey--text">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.entries"
						)
					}}
				</div>
				<div class="grey--text text--darken-2 border-bottom">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.commentByMe"
						)
					}}
				</div>
				<div class="grey--text text--darken-2 border-bottom">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.commentMentions"
						)
					}}
				</div>
				<div class="grey--text text--darken-2 border-bottom">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.commentBySomeone"
						)
					}}
				</div>
			</div>

			<div class="d-flex flex-column align-center">
				<div class="grey--text">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.email"
						)
					}}
				</div>
				<v-checkbox
					v-model="settings.comment_user_post_email"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
				<v-checkbox
					v-model="settings.mark_in_post_email"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
				<v-checkbox
					v-model="settings.comment_observed_post_email"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
			</div>
			<div class="d-flex flex-column align-center">
				<div class="grey--text">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.desktop"
						)
					}}
				</div>
				<v-checkbox
					v-model="settings.comment_user_post_desktop"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
				<v-checkbox
					v-model="settings.mark_in_post_desktop"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
				<v-checkbox
					v-model="settings.comment_observed_post_desktop"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
			</div>
			<div class="d-flex flex-column align-center">
				<div class="grey--text">Aplikacja mobilna</div>
				<v-checkbox
					v-model="settings.comment_user_post_mobile"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
				<v-checkbox
					v-model="settings.mark_in_post_mobile"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
				<v-checkbox
					v-model="settings.comment_observed_post_mobile"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
			</div>
		</div>

		<div class="d-flex my-9">
			<div
				class="d-flex flex-column justify-space-between notifications-titles-container"
			>
				<div class="grey--text">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.groups"
						)
					}}
				</div>
				<div class="grey--text text--darken-2 border-bottom">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.groupsNewPost"
						)
					}}
				</div>
				<div class="grey--text text--darken-2 border-bottom">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.groupsNewMember"
						)
					}}
				</div>
			</div>

			<div class="d-flex flex-column align-center">
				<div class="grey--text">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.email"
						)
					}}
				</div>
				<v-checkbox
					v-model="settings.new_post_in_group_email"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
				<v-checkbox
					v-model="settings.new_member_in_group_email"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
			</div>
			<div class="d-flex flex-column align-center">
				<div class="grey--text">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.desktop"
						)
					}}
				</div>
				<v-checkbox
					v-model="settings.new_post_in_group_desktop"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
				<v-checkbox
					v-model="settings.new_member_in_group_desktop"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
			</div>
			<div class="d-flex flex-column align-center">
				<div class="grey--text">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.mobile"
						)
					}}
				</div>
				<v-checkbox
					v-model="settings.new_post_in_group_mobile"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
				<v-checkbox
					v-model="settings.new_member_in_group_mobile"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
			</div>
		</div>

		<div class="d-flex">
			<div
				class="d-flex flex-column justify-space-between notifications-titles-container"
			>
				<div class="grey--text">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.tasklist"
						)
					}}
				</div>
				<div class="grey--text text--darken-2 border-bottom">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.taskDeadline"
						)
					}}
				</div>
				<div class="grey--text text--darken-2 border-bottom">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.taskRecieve"
						)
					}}
				</div>
			</div>
			<v-spacer></v-spacer>

			<div class="d-flex flex-column align-center">
				<div class="grey--text">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.email"
						)
					}}
				</div>
				<v-checkbox
					v-model="settings.due_date_approaching_email"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
				<v-checkbox
					v-model="settings.assigned_task_email"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
			</div>
			<div class="d-flex flex-column align-center">
				<div class="grey--text">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.desktop"
						)
					}}
				</div>
				<v-checkbox
					v-model="settings.due_date_approaching_desktop"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
				<v-checkbox
					v-model="settings.assigned_task_desktop"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
			</div>
			<div class="d-flex flex-column align-center">
				<div class="grey--text">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.notifications.mobile"
						)
					}}
				</div>
				<v-checkbox
					v-model="settings.due_date_approaching_mobile"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
				<v-checkbox
					v-model="settings.assigned_task_mobile"
					color="accent"
					hide-details
					class="border-bottom pl-11 pr-11"
				></v-checkbox>
			</div>
		</div>

		<div class="d-flex justify-center mt-9">
			<v-btn
				@click="updateNotifications"
				:loading="this.isLoading"
				color="accent"
				elevation="0"
			>
				{{
					$vuetify.lang.t(
						"$vuetify.views.settings.notifications.actualNotifications"
					)
				}}
			</v-btn>
		</div>
	</div> -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import ComingSoon from "@/components/ComingSoon";

export default {
	components: {
		ComingSoon,
	},
	data() {
		return {
			isLoading: false,
			isSuccess: false,
			isError: false,
		};
	},
	computed: {
		...mapGetters({ settings: "notifications/settings" }),
	},
	methods: {
		...mapActions("notifications", ["saveSettings", "getSettings"]),
		async updateNotifications() {
			this.isLoading = true;
			const res = await this.saveSettings(this.settings);
			this.isLoading = false;

			if (res.success) {
				this.isSuccess = true;
			} else {
				this.isError = true;
			}
		},
	},
	created() {
		if (!Object.keys(this.settings).length) {
			this.getSettings();
		}
	},
};
</script>

<style scoped>
.border-bottom {
	border-bottom: 1px solid var(--v-grey-lighten4);
	padding-bottom: 24px;
}

.notifications-titles-container {
	width: 100%;
}
</style>
